module.exports = __webpack_public_path__ + "static/media/calling.14878a81.ogg";